import React from 'react';
import FormItemConst from '../../formItem/FormItemConst';
import {LookupAutoQueryStore} from '../../stores/LookupStores';
import FormItemStringResolver from '../../formItem/resolver/FormItemStringResolver';

export default class AutoLookupStringEditor extends React.Component
{
	constructor(props) 
	{
		super(props);
		this.state = {inQueryGroup:this.props.initFocus?true:false};
		this.classAlias = "AutoLookupStringEditor";
		this.unsubscribeLookupAutoQueryStore = LookupAutoQueryStore.listen(this.onLookupAutoQuery.bind(this));
	}

	componentDidMount()
	{
		if(this.props.initFocus)
		{
			let _inputField = this.inputField;
			setTimeout(function(){$(_inputField).focus();},500);
		}
	}

	onLookupAutoQuery(key,args)
	{
		if(this.props.lookupKey == key && this.state.inQueryGroup)
		{
			args[this.props.tableField.name] = FormItemConst.WILDCARD +this.record+ FormItemConst.WILDCARD;
		}
	}

	labelClickHandler()
	{
		this.setState({inQueryGroup:!this.state.inQueryGroup});
	}

	getInputDom()
	{
		let _id = this.props.id;
		let displayLength=this.props.displayLength;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';
		if(this.state.inQueryGroup)
		{
			return <input ref={node => this.inputField = node} id={_id} style={{width:_width,marginLeft:'5px',height:FormItemConst.EDITOR_HEIGHT,padding:'2px'}} spellCheck="false" className="form-control"  onBlur={this.inputFieldBlur.bind(this)}></input>
		}
		else
		{
			return <input ref={node => this.inputField = node}  onBlur={this.inputFieldBlur.bind(this)} readOnly="readonly" className="form-control" spellCheck="false" id={_id} style={{width:_width,height:FormItemConst.EDITOR_HEIGHT,marginLeft:'5px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,padding:'2px'}}></input>
		}
	}

	setFinalValue(value)
	{
		if(!value)
			value = $(this.inputField).val();

		value = FormItemStringResolver.getResult(value,this.props.trim,this.props.changeCase,this.props.stringSize,this.props.regular);
		if(value.indexOf(FormItemStringResolver.RESOLVER_FALSE_TAG) == 0)
		{
			alert(value.substr(FormItemStringResolver.RESOLVER_FALSE_TAG.length));
			return;
		}
	
		this.record = value;
	}

	inputFieldBlur()
	{
		this.setFinalValue();
		//todo 值回送数据完成以后 严格按照显示要求再进行显示
		this.setDisplay();
	}

	setDisplay(value)
	{
		if(value == null || value == undefined)
		{
			value = this.record;
		}
		$(this.inputField).val(value);
	}

	render()
	{
		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		let _id = this.props.id;
		let labelStyle={paddingLeft:'5px',width:'auto',cursor:'pointer',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
		if(!this.state.inQueryGroup)
		{
			labelStyle.color = "#CFCFCF";
		}
		let inputDom = this.getInputDom();
		return(
			<div ref={node => this.element = node} className='editorGroup' style={editorStyle}>
				<label htmlFor={_id} className="fieldGroupLabel" ref={node => this.componentLabel = node}
					style={labelStyle} onClick={this.labelClickHandler.bind(this)}>
					{this.props.label}
				</label>
				{inputDom}
			</div>
		);
		
	}

}


// WEBPACK FOOTER //
// ./src/components/autoLookup/AutoLookupStringEditor.js